var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImaging({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5C0 4.97715 4.47715 0.5 10 0.5H46C51.5228 0.5 56 4.97715 56 10.5V44.5C56 50.0228 51.5228 54.5 46 54.5H10C4.47715 54.5 0 50.0228 0 44.5V10.5Z",
    fill: "#001E36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5605 38.2456V14.9082C12.5605 14.7256 12.6336 14.6525 12.8162 14.6525C14.3136 14.5795 17.1988 14.543 19.9745 14.543C27.3519 14.543 29.8719 18.6334 29.8719 22.5778C29.8719 28.4943 25.3066 31.0143 19.7188 31.0143C18.6962 31.0143 18.5136 31.0143 17.6371 31.0143V38.2091C17.6371 38.4282 17.564 38.5012 17.3084 38.5012H12.8527C12.6701 38.5012 12.5605 38.4282 12.5605 38.2456ZM17.6371 18.9986V26.5586C18.2579 26.5951 18.6597 26.5951 19.6823 26.5951C22.531 26.5951 24.8684 25.7186 24.8684 22.6873C24.8684 20.3864 23.2979 18.9256 20.084 18.9256C18.9519 18.9256 17.9658 18.9621 17.6371 18.9986Z",
    fill: "#31A8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6035 25.0978C42.4348 24.5134 40.5722 24.0386 38.9287 24.0386C37.2122 24.0386 36.6278 24.696 36.6278 25.3169C36.6278 25.9378 37.1026 26.376 39.2574 27.216C43.6765 28.823 45.0643 30.5395 45.0643 33.1325C45.0643 36.5656 42.3617 38.8664 37.5408 38.8664C35.2765 38.8664 33.3408 38.4647 32.2087 37.8804C32.0261 37.7708 31.9895 37.6612 31.9895 37.4421V33.4978C31.9895 33.2786 32.0991 33.2056 32.2452 33.3151C33.9252 34.3378 35.9704 34.776 37.6139 34.776C39.3304 34.776 40.0974 34.3012 40.0974 33.4978C40.0974 32.8038 39.513 32.2925 37.3582 31.4891C33.2313 29.9551 31.8435 28.2386 31.8435 25.6091C31.8435 22.7604 34.1443 20.0212 39.0017 20.0212C41.1565 20.0212 42.8365 20.2769 43.7495 20.7517C43.9687 20.8612 43.9687 21.0073 43.9687 21.2264V24.8786C43.9687 25.0612 43.8591 25.2073 43.6035 25.0978Z",
    fill: "#31A8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 54,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImaging);
export default __webpack_public_path__ + "static/media/Imaging.316b59832408cae2b4b01d4caa141dc2.svg";
export { ForwardRef as ReactComponent };